import { MarginInfoUtils } from "./MarginInfoUtils";
// groups
export const KEY_GROUP_RISKS = 'OrderEntry.InfoBlock.1.Risks';
export const KEY_GROUP_FEES = 'OrderEntry.InfoBlock.2.Fees';
// fields' localization keys
// 1.Risks
export const KEY_BALANCE = 'OrderEntry.InfoBlock.Balance';
export const KEY_AVAILABLE_FUNDS = 'OrderEntry.InfoBlock.Availible funds';
export const KEY_INCOMING_FUNDS = 'OrderEntry.InfoBlock.Incoming funds';
export const KEY_MARGIN_AVAILABLE = 'OrderEntry.InfoBlock.Margin availible';
export const KEY_IMPACT_ON_FUNDS = 'OrderEntry.InfoBlock.Impact on portfolio';
export const KEY_IMPACT_ON_MARGIN = 'OrderEntry.InfoBlock.Impact on margin';
export const KEY_AFTER_TRADE_FUNDS = 'OrderEntry.InfoBlock.After trade funds';
export const KEY_AFTER_TRADE_MARGIN = 'OrderEntry.InfoBlock.After trade margin';
export const KEY_BLOCKED_FOR_STOCKS = 'OrderEntry.InfoBlock.Blocked for Stocks';
export const KEY_SPREAD_INIT_LOSS = 'OrderEntry.InfoBlock.Spread in loss';
export const KEY_PL_PER_TICK = 'OrderEntry.InfoBlock.P/L per Tick';
export const KEY_ALLOW_SHORT_POSITIONS = 'OrderEntry.InfoBlock.Allow short positions';
export const KEY_EST_AVAILABLE_CASH = 'OrderEntry.InfoBlock.After trade cash';
export const BLOCKED_FOR_FIXED_INCOME = 'OrderEntry.InfoBlock.Blocked for fixed income';
// 2.Fees
export const KEY_FILL_PER_LOT = 'OrderEntry.InfoBlock.FillPerLot';
export const KEY_ORDER_PER_LOT = 'OrderEntry.InfoBlock.OrderPerLot';
export const KEY_ORDER_PER_LOT_WITH_FIXED_PART = 'OrderEntry.InfoBlock.OrderPerLotWithFixedPart';
export const KEY_FILL_VOLUME = 'OrderEntry.InfoBlock.FillVolume';
export const KEY_FILL_VOLUME_WITH_MIN_PD = 'OrderEntry.InfoBlock.FillVolumeWithMinPD';
export const KEY_PER_FILL = 'OrderEntry.InfoBlock.PerFill';
export const KEY_PER_TRANSACTION = 'OrderEntry.InfoBlock.PerTransaction';
export const KEY_PER_PHONE_TRANSACTION = 'OrderEntry.InfoBlock.PerPhoneTransaction';
export const KEY_VAT = 'OrderEntry.InfoBlock.VAT';
export const KEY_ORDER_VOLUME = 'OrderEntry.InfoBlock.OrderVolume';
export const KEY_SHORT_SWAP_INFO = 'OrderEntry.InfoBlock.SwapDetails';
export const KEY_FREE_COMMISSION = 'OrderEntry.InfoBlock.Free commission';
export const KEY_TOTAL_FEES = 'OrderEntry.InfoBlock.TotalFee';
export const KEY_LONG_SWAP = 'OrderEntry.InfoBlock.LongSwap';
export const KEY_SHORT_SWAP = 'OrderEntry.InfoBlock.ShortSwap';
export const KEY_ORDER_CARE = 'OrderEntry.InfoBlock.CareOrder';
export const KEY_FILL_FACE_VALUE = 'OrderEntry.InfoBlock.FillFaceValue';
export const MARGIN_RESPONSE_DEP_KEYS = new Set([
    KEY_IMPACT_ON_FUNDS,
    KEY_IMPACT_ON_MARGIN,
    KEY_AFTER_TRADE_FUNDS,
    KEY_AFTER_TRADE_MARGIN,
    KEY_EST_AVAILABLE_CASH,
    KEY_LONG_SWAP,
    KEY_SHORT_SWAP,
    KEY_SHORT_SWAP_INFO,
    KEY_FILL_PER_LOT,
    KEY_ORDER_PER_LOT,
    KEY_ORDER_PER_LOT_WITH_FIXED_PART,
    KEY_FILL_VOLUME,
    KEY_ORDER_VOLUME,
    KEY_FILL_VOLUME_WITH_MIN_PD,
    KEY_PER_FILL,
    KEY_PER_TRANSACTION,
    KEY_VAT,
    KEY_FREE_COMMISSION,
    KEY_TOTAL_FEES,
    KEY_ORDER_CARE,
    KEY_FILL_FACE_VALUE,
]);
export function isMarginResponseDepType(type) {
    return isMarginResponseDepKey(MarginInfoUtils.getItemKey(type));
}
export function isMarginResponseDepKey(key) {
    return MARGIN_RESPONSE_DEP_KEYS.has(key);
}
const HIDDEN_UNTIL_RESPONSE_KEYS = new Set([
    KEY_SHORT_SWAP_INFO,
    KEY_EST_AVAILABLE_CASH,
    KEY_FREE_COMMISSION,
    KEY_ORDER_CARE
]);
export function isHiddenUntilResponseKey(key) {
    return HIDDEN_UNTIL_RESPONSE_KEYS.has(key);
}
